import { render } from "./ColorList.vue?vue&type=template&id=17f51292"
import script from "./ColorList.vue?vue&type=script&lang=js"
export * from "./ColorList.vue?vue&type=script&lang=js"

import "./ColorList.vue?vue&type=style&index=0&id=17f51292&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__